import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltIconDownloadOutline } from '@cae/cobalt-react/icons/outline/CobaltIconDownloadOutline';
import { useDownloadInvoice } from '@features/invoices/hooks/use-download-invoice/useDownloadInvoice';
import * as React from 'react';

import type { InvoiceDownloadCellProps } from './InvoiceDownloadCell.types';

import styles from './InvoiceDownloadCell.module.css';

const InvoiceDownloadCell = React.memo(
  ({
    accountReceivableId,
    transactionNumber,
  }: Readonly<InvoiceDownloadCellProps>): React.ReactElement => {
    const { handleDownload, isDownloading } = useDownloadInvoice({
      accountReceivableId,
      transactionNumber,
    });

    return (
      <CobaltButton
        variant="ghost"
        pending={isDownloading}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          void handleDownload();
        }}
        aria-label={`Download invoice ${transactionNumber || accountReceivableId}`}
        data-testid="invoice-download-cell-button"
        className={styles.downloadButton}
      >
        <CobaltIconDownloadOutline size="small" aria-hidden="true" />
      </CobaltButton>
    );
  }
);

InvoiceDownloadCell.displayName = 'InvoiceDownloadCell';
export { InvoiceDownloadCell };
